import React, { useState, useEffect } from "react";
import {
    Table,
    Button,
    Pagination,
    Form,
    Container,
    Row,
    Col,
} from "react-bootstrap";
import { APIURL } from "../config";
import { authFetch } from "../service/apiClient";
import { useNavigate } from "react-router-dom";
import Loading from "./loading";
import Snackbar from "./Snackbar";
const itemsPerPage = 10; // Number of items per page

const SortableTable = () => {
    const [data, setData] = useState([]);
    const [filteredData, setFilteredData] = useState([]); // State to hold filtered data
    const [, setSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [sortConfig, setSortConfig] = useState({
        key: null,
        direction: "ascending",
    });
    const [searchQuery, setSearchQuery] = useState(""); // State to hold the search query
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [snackbar, setSnackbar] = useState({ open: false, message: "", type: "info" });
    const closeSnackbar = () => setSnackbar((prev) => ({ ...prev, open: false }));
    useEffect(() => {
        setLoading(true)
        const fetchData = async () => {
            try {
                const response = await authFetch(APIURL + "/getAllSurvey");

                if (!response.ok) {
                    throw new Error(`Server error: ${response.status}`);
                }

                const jsonData = await response.json();
                setData(jsonData.data);
                setSortedData(jsonData.data);

            } catch (error) {
                setError('Failed to load survey data. Please try again.');
                setSnackbar({ open: true, message: "Failed to load survey data. Please try again.", type: "error" });
            }
            setLoading(false)

        };

        fetchData();
    }, []);

    useEffect(() => {
        const filtered = data.filter((item) =>
            Object.values(item).some((value) =>
                value !== null && value.toString().toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
        setFilteredData(filtered);
        setCurrentPage(1); // Reset to first page after search
    }, [searchQuery, data]);


    const formatDate = (timestamp) => {
        const date = new Date(timestamp); // timestamp is already a string
        return (
            date.toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
            }) +
            " " +
            date.toLocaleTimeString("en-US")
        );
    };


    const getNestedValue = (obj, key) => {
        return key.split('.').reduce((o, k) => (o || {})[k], obj) ?? null;
    };

    const requestSort = (key) => {
        let direction = "ascending";
        if (sortConfig.key === key && sortConfig.direction === "ascending") {
            direction = "descending";
        }
        setSortConfig({ key, direction });

        const sortedArray = [...data].sort((a, b) => {
            const aVal = getNestedValue(a, key);
            const bVal = getNestedValue(b, key);
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return direction === "ascending" ? 1 : -1;
            if (bVal == null) return direction === "ascending" ? -1 : 1;
            if (aVal < bVal) {
                return direction === "ascending" ? -1 : 1;
            }
            if (aVal > bVal) {
                return direction === "ascending" ? 1 : -1;
            }
            return 0;
        });

        setSortedData(sortedArray);
    };

const handleActionClick = (rowData) => {
    const data = {
        email: rowData.Email,
        first_name: rowData.Name,
        is_kit_registered: true,
        last_name: "",
    };
    localStorage.setItem('userInfo', JSON.stringify(data));

localStorage.setItem('loginOrigin', 'admin');

navigate('/home', { state: { fromAdmin: true } });
};

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const currentTableData = filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    return (
        <>
            {loading && <Loading message="Loading survey data..." />}
            <Snackbar message={snackbar.message} type={snackbar.type} open={snackbar.open} onClose={closeSnackbar} />
            {error && !loading && (
                <div className="text-center mt-5">
                    <p style={{ color: 'red' }}>{error}</p>
                    <button className="submit-button" onClick={() => window.location.reload()}>
                        Retry
                    </button>
                </div>
            )}
            {!loading && !error && (
            <>
            <h2 className="heading">DNA ANALYSIS KIT Admin</h2>
            <>
                <Container fluid>
                    <Row className="justify-content-between">
                        <Col md="auto">
                            <Form.Control
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                style={{ marginBottom: "-10px", width: "100%", maxWidth: "300px" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div style={{ overflowX: 'auto' }}>
                            <Table striped bordered hover>
                                <thead>
                                    <tr>
                                        <th onClick={() => requestSort("Email")}>Email</th>
                                        <th onClick={() => requestSort("Name")}>Name</th>
                                        <th onClick={() => requestSort("PetName")}>PetName</th>
                                        <th onClick={() => requestSort("Kit_id")}>Kit ID</th>
                                        <th onClick={() => requestSort("StartTime")}>StartTime</th>
                                        <th onClick={() => requestSort("CompletionTime")}>
                                            CompletionTime
                                        </th>
                                        <th onClick={() => requestSort("survey.datePublished")}>
                                            Report Published
                                        </th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentTableData.map((item, index) => (
                                        <tr key={index}>
                                            <td>{item?.Email}</td>
                                            <td>{item?.Name}</td>
                                            <td>{item?.PetName}</td>
                                            <td>{item?.Kit_id}</td>
                                            <td>{formatDate(item?.StartTime)}</td>
                                            <td>{formatDate(item?.CompletionTime)}</td>
                                            <td>
                                                {item?.survey?.datePublished ? (
                                                    <span style={{ color: "green", fontWeight: "bold" }}>
                                                        {formatDate(item.survey.datePublished * 1000)}
                                                    </span>
                                                ) : (
                                                    <span style={{ color: "gray" }}>Not Published</span>
                                                )}
                                            </td>
                                            <td>
                                                <Button
                                                    className="reportButton"
                                                    variant="primary"
                                                    onClick={() => handleActionClick(item)}
                                                >Preview Data
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            </div>
                            <Pagination className="justify-content-center">
                                <Pagination.First
                                    onClick={() => setCurrentPage(1)}
                                    disabled={currentPage === 1}
                                />
                                <Pagination.Prev
                                    onClick={() => setCurrentPage(currentPage - 1)}
                                    disabled={currentPage === 1}
                                />
                                {[...Array(totalPages).keys()].map((number) => (
                                    <Pagination.Item
                                        key={number + 1}
                                        active={number + 1 === currentPage}
                                        onClick={() => setCurrentPage(number + 1)}
                                    >
                                        {number + 1}
                                    </Pagination.Item>
                                ))}
                                <Pagination.Next
                                    onClick={() => setCurrentPage(currentPage + 1)}
                                    disabled={currentPage === totalPages}
                                />
                                <Pagination.Last
                                    onClick={() => setCurrentPage(totalPages)}
                                    disabled={currentPage === totalPages}
                                />
                            </Pagination>
                        </Col>
                    </Row>
                </Container>
            </>
            </>
            )}
        </>
    );
};

export default SortableTable;
